module.exports = __webpack_public_path__ + "img/sleepy.c1999f73.png";